import type { ReactNode } from "react";

import { cn } from "../lib/cn";

export interface ErrorComponentProps {
  title: string;
  description: string;
  status?: number;
  action?: ReactNode;
  className?: string;
}

export function ErrorComponent({
  title,
  description,
  status,
  action,
  className,
}: ErrorComponentProps) {
  return (
    <div className={cn(className)} data-testid="error-component">
      {status ? (
        <p className="mb-2 text-base font-semibold text-primary">{status}</p>
      ) : null}
      <h1 className="text-3xl font-bold tracking-tight sm:text-5xl">{title}</h1>
      <p className="mt-2 text-base leading-7 text-muted-foreground">
        {description}
      </p>
      {action ? (
        <div className="mt-4 block text-base font-semibold text-primary">
          {action}
        </div>
      ) : null}
    </div>
  );
}
